import type { FC, ReactNode } from "react";

import type { IconName } from "@similarweb/icons";
import type { ButtonType } from "@similarweb/ui-components";
import { IconButton, PlainTooltip } from "@similarweb/ui-components";

type ItemsButtonCellProp = {
    onClick?: (row?: FixmeType) => void;
    iconButtonLabel: ReactNode;
    iconButtonType?: ButtonType;
    buttonIconName?: IconName;
    isDisabled?: boolean;
    iconButtonIconSize?: string;
    iconButtonWidth?: string;
    iconButtonHeight?: string;
    tooltipEnabled?: boolean;
    tooltipContent?: string;
    row?: any;
};

export const ItemsButtonCell: FC<ItemsButtonCellProp> = ({
    iconButtonLabel,
    iconButtonType = "flat",
    onClick,
    buttonIconName = "plus",
    isDisabled,
    iconButtonIconSize = "xs",
    iconButtonWidth,
    iconButtonHeight,
    row,
    tooltipEnabled = false,
    tooltipContent,
}) => {
    const handleOnClick = () => {
        onClick?.(row);
    };

    return (
        <PlainTooltip
            enabled={tooltipEnabled}
            tooltipContent={tooltipContent}
        >
            <div>
                <IconButton
                    iconName={buttonIconName}
                    type={iconButtonType}
                    iconSize={iconButtonIconSize}
                    onClick={handleOnClick}
                    isDisabled={isDisabled}
                    width={iconButtonWidth}
                    height={iconButtonHeight}
                >
                    {iconButtonLabel}
                </IconButton>
            </div>
        </PlainTooltip>
    );
};
